import IhmException from '@ch-types/CoralExceptionTypes/IhmException';

export default class NotFoundException extends IhmException {}
